import React from 'react';
import { ModifierGroupInterface } from '../../../services/exports/Interfaces';
import { BasketLineItemModifier } from '../../../store/types';
import NestedModifierGroupItem from './NestedModifierGroupItem';

type NestedModifierProps = {
  modifierGroup: ModifierGroupInterface;
  selectedModifiers: BasketLineItemModifier[];
};

const NestedModifierGroup = (props: NestedModifierProps) => {
  const { modifierGroup, selectedModifiers } = props;

  return (
    <div className="flex flex-col items-start">
      <p>{modifierGroup.name}</p>
      {selectedModifiers.map((lineItem) => (
        <NestedModifierGroupItem key={`${lineItem.modifier_id}_${lineItem.modifier_type}`} data={lineItem} />
      ))}
    </div>
  );
};

export default NestedModifierGroup;
